import { render, staticRenderFns } from "./index-news.vue?vue&type=template&id=e4f8b67c&scoped=true&"
import script from "./index-news.vue?vue&type=script&lang=js&"
export * from "./index-news.vue?vue&type=script&lang=js&"
import style0 from "./index-news.vue?vue&type=style&index=0&id=e4f8b67c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f8b67c",
  null
  
)

export default component.exports